'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLIENT_HANDOFF = exports.CLIENT_HANDOFF = '@wh/site-base-app-container/CLIENT_HANDOFF';
exports.default = {};
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-client-handoff-action/dist/main/constants.js
// module id = 265
// module chunks = 0